import React from 'react';
import { BedDouble, Bath, Droplet, CloudSun, ChefHat, Armchair, Archive, CornerDownRight, CircleParking } from 'lucide-react';
import './roomPresetBar.scss';

// اندازه‌های پیش‌فرض هر فضا بر حسب سانتی‌متر (هم‌راستا با واحد جهانی نقشه: ۱ پیکسل = ۱ سانتی‌متر)
export const ROOM_PRESETS = [
  { key: 'bedroom', label: 'اتاق خواب', width: 300, height: 300, icon: BedDouble },
  { key: 'bathroom', label: 'حمام', width: 150, height: 200, icon: Bath },
  { key: 'toilet', label: 'سرویس بهداشتی', width: 100, height: 150, icon: Droplet },
  { key: 'balcony', label: 'بالکن', width: 120, height: 300, icon: CloudSun },
  { key: 'kitchen', label: 'آشپزخانه', width: 250, height: 300, icon: ChefHat },
  { key: 'living', label: 'پذیرایی', width: 400, height: 400, icon: Armchair },
  { key: 'storage', label: 'انباری', width: 150, height: 150, icon: Archive },
  { key: 'hallway', label: 'راهرو', width: 100, height: 300, icon: CornerDownRight },
  { key: 'parking', label: 'پارکینگ', width: 250, height: 500, icon: CircleParking },
];

function RoomPresetBar({ onSelect }) {
  return (
    <div className="room-preset-bar">
      <div className="room-preset-bar__scroll">
        {ROOM_PRESETS.map((preset) => {
          const Icon = preset.icon;
          return (
            <button key={preset.key} type="button" className="room-preset-bar__chip" onClick={() => onSelect(preset)}>
              <Icon size={16} strokeWidth={1.8} />
              <span>{preset.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default RoomPresetBar;